<div class="subtitle">
    {{ idx + 1 }}. {{ tip.title | translate }}
</div>
<div class="body" [innerHTML]="tip.body | translate">
</div>
